export const environment = {
  title: "Quentin Petel - Ingénieur étude et développement Web",
  keywords: `Quentin, Petel, Ingénieur, Régie, Web, API, REST, Docker, Node, React, Angular, Développeur, Architecte, IT, IT-era, 2pulse`,
  description: `Curriculum Vitae de Quentin Petel, ingénieur étude et développement web, architecte à IT-era (https://it-era.dev)`,
  baseUrl: "/",
  // head: {
  //   link: [],
  //   meta: [
  //     { name: "keywords", content: params.keywords },
  //     { name: "description", content: params.description },

  //     // Open Graph meta properties
  //     { property: "og:url", content: params.fullUrl },
  //     { property: "og:type", content: "website" },
  //     { property: "og:site_name", content: params.title },
  //     { property: "og:title", content: params.title },
  //     { property: "og:description", content: params.description },
  //     {
  //       property: "og:image",
  //       content: params.fullUrl + "/assets/img/profile-circle.png",
  //     },
  //     { property: "og:locale", content: "fr_FR" },

  //     // Security
  //     {
  //       "http-equiv": "Content-Security-Policy",
  //       content: `
  //         default-src
  //           'none';
  //         manifest-src
  //           'self';
  //         frame-src
  //           https://*.facebook.com;
  //         font-src
  //           ${params.fullUrl}
  //           https://fonts.gstatic.com
  //           https://fonts.googleapis.com;
  //         img-src
  //           'self'
  //           ${params.fullUrl}
  //           https://www.facebook.com
  //           https://www.google-analytics.com
  //           https://stats.g.doubleclick.net
  //           data:;
  //         media-src
  //           'self'
  //           ${params.fullUrl}
  //         style-src
  //           'self'
  //           'unsafe-inline'
  //           ${params.fullUrl}
  //           https://fonts.googleapis.com;
  //         script-src
  //           'self'
  //           'unsafe-inline'
  //           'unsafe-eval'
  //           ${params.fullUrl}
  //           connect.facebook.net
  //           https://www.facebook.com
  //           https://www.google-analytics.com;
  //         connect-src
  //           'self'
  //           ${params.fullUrl}`,
  //     },
  //     // Default language
  //     { "http-equiv": "content-language", content: "fr-FR" },

  //     // Microsoft App
  //     { name: "msapplication-TileColor", content: "#1a1a1a" },
  //     {
  //       name: "msapplication-TileImage",
  //       content:
  //         params.fullUrl + "/assets/icons/mstile-144x144.png?v=zXbBvL99j8",
  //     },
  //     {
  //       name: "msapplication-config",
  //       content:
  //         params.fullUrl + "/assets/icons/browserconfig.xml?v=zXbBvL99j8",
  //     },
  //     { name: "theme-color", content: "#1a1a1a" },

  //     // Bing verification
  //     // { name: 'msvalidate.01', content: 'FB9E17C1145B48F12DE19EB133756C3E' },

  //     // Facebook verification
  //     // { property: 'fb:app_id', content: '662412830616846' },

  //     // Homescreen for ios
  //     { name: "apple-mobile-web-app-capable", content: "yes" },
  //     { name: "apple-mobile-web-app-status-bar-style", content: "black" },
  //   ],
  // },
};
